"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.currencyPrecision = exports.convertToCurrency = void 0;
var GeneralSettings_1 = require("../constants/GeneralSettings");
var numberHelpers_1 = require("./numberHelpers");
function isPrice(obj) {
    return 'price' in obj;
}
var convertToCurrency = function (value, rate, all, currency, convertToDecimal) {
    if (convertToDecimal === void 0) { convertToDecimal = true; }
    var result = value.map(function (val) {
        var _a;
        var v = isPrice(val)
            ? parseFloat(val.price)
            : parseFloat(val.monthly_mortgage_amd);
        var toRate = rate || 1;
        var currencyName = GeneralSettings_1.CURRENCIES[val.currency];
        var fromRate = parseFloat((_a = all[currencyName]) === null || _a === void 0 ? void 0 : _a.Rate) || 1;
        var converted = isPrice(val)
            ? (fromRate / toRate) * v
            : Math.ceil((fromRate / toRate) * v);
        return convertToDecimal
            ? numberHelpers_1.numberToDecimalString(roundUpPriceWithCurrency(converted.toFixed(0), currency))
            : converted.toFixed(0);
    });
    return joinConvertedPrices(result);
};
exports.convertToCurrency = convertToCurrency;
exports.currencyPrecision = {
    amd: 1000,
    usd: 10,
    rub: 1000,
};
var roundUpPriceWithCurrency = function (price, currency) {
    return numberHelpers_1.roundUp(price, exports.currencyPrecision[currency]);
};
var joinConvertedPrices = function (prices) {
    return prices.join('-');
};
